import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBento: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bento, layout, grid, flex"} maskId="square-filled-radius-0-stroke-1-IconBento"><path d="M11 21H3V13H11V21Z" fill="currentColor"/><path d="M21 21H13V3H21V21Z" fill="currentColor"/><path d="M11 11H3V3H11V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBento;
